import styled, { css } from 'styled-components';

// Assets

// Interface
interface Props {
  align: 'left' | 'right' | 'center';
  buy?: boolean;
}

export const Container = styled.h3<Props>`
  color: #00205b;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
  margin-top: 20px;
  text-align: ${({ align }) => align};

  ${({ buy }) =>
    buy &&
    css`
      margin-bottom: 35px;
      margin-top: 0;

      @media (orientation: portrait) {
        font-size: 14px;
        margin-bottom: 25px;
      }
    `}
`;
